import FiltersOptionState from '../store/schema/FiltersOptionState';
import getBlockContentFromUnknownSenders from './getBlockContentFromUnknownSenders';
import getFiltersOption from '../store/store';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { select } from 'satcheljs/lib/legacy';

export interface FiltersOptionDirtyState {
    filtersOption: FiltersOptionState;
    blockContentFromUnknownSenders: boolean;
    mailboxJunkEmailConfiguration: MailboxJunkEmailConfigurationOptions;
}

export default select<FiltersOptionDirtyState>({
    filtersOption: () => getFiltersOption(),
    blockContentFromUnknownSenders: () => getBlockContentFromUnknownSenders(),
    mailboxJunkEmailConfiguration: () => getMailboxJunkEmailConfiguration(),
})(function isFiltersOptionDirty(state?: FiltersOptionDirtyState) {
    let { filtersOption, blockContentFromUnknownSenders, mailboxJunkEmailConfiguration } = state;

    return (
        (filtersOption.trustedListsOnly !== null &&
            filtersOption.trustedListsOnly !== mailboxJunkEmailConfiguration.TrustedListsOnly) ||
        (filtersOption.contactsTrusted !== null &&
            filtersOption.contactsTrusted !== mailboxJunkEmailConfiguration.ContactsTrusted) ||
        (filtersOption.blockContentFromUnknownSenders !== null &&
            filtersOption.blockContentFromUnknownSenders !== blockContentFromUnknownSenders)
    );
});
